import { countiesList } from '../model/StaticVariables';
import { useCallback, useContext, useEffect, useState } from 'react';
import { InterfaceContext } from '../model/InterfaceProvider';
import { Downloader as CSVDown } from './DownloadCSV';
import { Downloader as JPGDown } from './DownloadJPG';

import DownloadContext, { DownloadProvider } from './DownloadProvider';

const AppDownloadController = () => {
    const countyFips = countiesList.map((a) => a.CC);
    const { scope, tract, theme, usState: aState, year, fipsInView } = useContext(InterfaceContext);
    const { csv, map, downloading, completeDownload, filter, printState, set_csv_link, set_map_link, set_doc_link, csv_link, map_link, doc_link } = useContext(DownloadContext);
    const [selectedFips, setSelectedFips] = useState(countyFips);
    const [selectedState, setSelectedState] = useState(false);
    const [csvComplete, set_csvComplete] = useState(true);
    const [mapComplete, set_mapComplete] = useState(true);
    const [docComplete, set_docComplete] = useState(true);
    const dataProps = { scope, tract, theme, usState: aState, csvState: printState || aState, filter, year: year.label };

    //ΔVΔVΔ: When downloading begins, set complete status to false
    useEffect(() => {
        if (!downloading) return;
        if (csv) set_csvComplete(false); //if csv is selected then set
        if (map) set_mapComplete(false);
    }, [downloading]);

    useEffect(() => {
        setFipsAndState();
    }, [scope, aState, filter, printState, fipsInView]);

    const setFipsAndState = () => {
        var tehState = printState ? printState : aState;
        if (scope === 'state') {
            setSelectedFips([tehState.id]);
            setSelectedState(tehState);
            return;
        }
        if (filter === 'current') {
            setSelectedFips(fipsInView);
        } else if (filter === 'usmap') {
            setSelectedFips(countyFips);
        } else if (filter === 'state') {
            setSelectedFips([printState.id]);
            setSelectedState(filter === 'state' ? tehState : false);
        }
    };
    //ΔVΔVΔ: When each download action completes, check to see if both are done then set loading to false
    useEffect(() => {
        if (!downloading || !csvComplete || !mapComplete || !docComplete) return;
        completeDownload();
    }, [csvComplete, mapComplete, docComplete]);

    // when csv is selected, delay trigger download until after csv

    return (
        <>
            <CSVDown
                year={year}
                dataProps={{ ...dataProps, fips: selectedFips }}
                triggerDownload={csv && !csvComplete}
                filename={'svi_interactive_map.csv'}
                onDownload={(link) => {
                    set_csv_link(link);
                    set_csvComplete(true);
                }}
                onDownloadDoc={(link) => {
                    set_doc_link(link);
                    set_docComplete(true);
                }}
            />
            <JPGDown
                // dataProps={dataProps}
                filter={filter}
                restoreState={aState}
                printState={selectedState}
                triggerDownload={csvComplete && map && !mapComplete}
                dimensions={[11 * 72, 8 * 72]}
                dpi={72}
                filename={'svi_interactive_map.jpg'}
                onDownload={(link) => {
                    // setPDF(false);
                    set_map_link(link);
                    set_mapComplete(true);
                }}
            />
        </>
    );
};

const AppDownloader = ({ children }) => {
    return (
        <DownloadProvider>
            <AppDownloadController />
            {children}
        </DownloadProvider>
    );
};
export default AppDownloader;
